import { render, staticRenderFns } from "./DataObjectView.vue?vue&type=template&id=095a3dbc&"
import script from "./DataObjectView.vue?vue&type=script&lang=js&"
export * from "./DataObjectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports